import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { ApiSysService } from '@services/api/api-sys.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const AuthRedirectGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const apiSysService = inject(ApiSysService);

  if (!auth.isLoggedIn()) {
    auth.login(state.url);
    return false;
  }

  return apiSysService.getPersonnelPreferences(auth.getUserId()).pipe(
    map(preferences => {
      const url = preferences?.preferred_url ?? '/landing';
      return router.createUrlTree([url]);
    }),
    catchError(() => of(router.createUrlTree(['/landing'])))
  );
};
